import { useMutation } from "@tanstack/react-query";
import { ApiResponse } from "@/shared/types/api.ts";
import {
  exportData,
  IExportInput,
  IExportResponse,
} from "@/export/api/requests/export.requests";

// Mutation to export data to Excel
export const useExportData = () => {
  return useMutation<ApiResponse<IExportResponse>, Error, IExportInput>({
    mutationFn: exportData,
    onSuccess: (response) => {
      if (response.data?.url) {
        const link = document.createElement('a');
        link.href = response.data.url;
        link.download = `export_${new Date().toISOString().split('T')[0]}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    onError: (error) => {
      console.error("Error exporting data:", error);
    },
  });
};

// Hook for manual download (if you want to handle the download differently)
export const useExportDataManual = () => {
  return useMutation<ApiResponse<IExportResponse>, Error, IExportInput>({
    mutationFn: exportData,
    onError: (error) => {
      console.error("Error exporting data:", error);
    },
  });
};